module.exports = __webpack_public_path__ + "static/media/banner_mobil.0d7b3f1d.png";